import { dateMath } from '@grafana/data';

function evaluateTimeRange(from, to, timeZone, fiscalYearStartMonth) {
  return {
    from: dateMath.parse(from, false, timeZone, fiscalYearStartMonth),
    to: dateMath.parse(to, true, timeZone, fiscalYearStartMonth),
    raw: {
      from,
      to
    }
  };
}

export { evaluateTimeRange };
//# sourceMappingURL=evaluateTimeRange.js.map
